import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Row, Col, Layout } from "antd";

import LandingHeader from "./common/Header";
import LandingMain from "./common/Main";
import LandingFooter from "./common/Footer";
import { linesToParagraphs } from "./common/Functions";
import Graph from "./common/Graph";

import "./css/Solutions.css";

const { Content } = Layout;

class Solutions extends React.Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired
  };

  render() {
    const { isLoggedIn } = this.props;
    return (
      <Layout className="landing landing__solutions">
        <LandingHeader isLoggedIn={isLoggedIn}>
          <Link to="/">
            <span>Conduster</span>
          </Link>
        </LandingHeader>
        {/*___________________________________________________*/}
        {/*_________________ C O N T E N T ___________________*/}
        {/*___________________________________________________*/}
        <Content className="landing__content">
          <LandingMain
            headerId="landing.contentHeader_solutions.line"
            subtitleId="landing.contentSubtitle_solutions.line"
          >
            <Col className="landing__content--benefit" xs={24} sm={24} lg={24}>
              <FormattedMessage
                id="landing.contentBenefit_solutions"
                defaultMessage="We help our clients - advertisers, affiliate networks and advertising agencies – operate in atmosphere of transparency and trust"
                description="About route. text for benefit item"
              />
            </Col>
          </LandingMain>
          <div className="bg-white">
            <div className="container">
              {/*___________________________________________________*/}
              {/*_________________A N A L Y T I C S_________________*/}
              {/*___________________________________________________*/}
              <Row
                className="landing__content--analytics"
                justify="space-between"
                type="flex"
              >
                <Col
                  className="landing__content--analytics-desc"
                  xs={24}
                  sm={24}
                  md={12}
                  lg={14}
                >
                  <h2>
                    <FormattedMessage
                      id="landing.solutions_analytics.title"
                      defaultMessage="End-to-end marketing analytics"
                      description="Header for analytics section"
                    />
                  </h2>
                  <FormattedMessage
                    id="landing.solutions_analytics.description1"
                    defaultMessage="Conduster provides you with the complete set of data necessary to determine the origin and history of your leads."
                    description="Description for analytics #1"
                  />
                  <br />
                  <FormattedMessage
                    id="landing.solutions_analytics.description2"
                    defaultMessage="We define all the points that the client has passed on all sites and from all devices"
                    description="Description for analytics #2"
                    values={{
                      strong: <strong>Customer journey</strong>
                    }}
                  />
                  <br />
                  <FormattedMessage
                    id="landing.solutions_analytics.description3"
                    defaultMessage="You get a full idea of how deeply the customer is interested in the product"
                    description="Description for analytics #3"
                  />
                </Col>
                <Col
                  className="landing__content--analytics-img"
                  xs={24}
                  sm={24}
                  md={12}
                  lg={10}
                >
                  <div className="landing__content--analytics-day1">
                    <h3>1</h3>
                    <p className="subtitle">
                      <FormattedMessage
                        id="landing.solutions_day"
                        defaultMessage="Day"
                        description="Day"
                      />
                      <span className="landing__content--analytics-wrap">
                        <FormattedMessage
                          id="landing.solutions_analytics.day1"
                          defaultMessage="The client examines the loan rates"
                          description="Description for analytics day 1"
                        >
                          {linesToParagraphs}
                        </FormattedMessage>
                      </span>
                    </p>
                  </div>
                  <div className="landing__content--analytics-day6">
                    <h3>6</h3>
                    <p className="subtitle">
                      <FormattedMessage
                        id="landing.solutions_day"
                        defaultMessage="Day"
                        description="Day"
                      />
                      <span className="landing__content--analytics-wrap">
                        <FormattedMessage
                          id="landing.solutions_analytics.day6"
                          defaultMessage="The client studies loan providers: banks and MFIs"
                          description="Description for analytics day 6"
                        >
                          {linesToParagraphs}
                        </FormattedMessage>
                      </span>
                    </p>
                  </div>
                  <div className="landing__content--analytics-day13">
                    <h3>13</h3>
                    <p className="subtitle">
                      <FormattedMessage
                        id="landing.solutions_day"
                        defaultMessage="Day"
                        description="Day"
                      />
                      <span className="landing__content--analytics-wrap">
                        <FormattedMessage
                          id="landing.solutions_analytics.day13"
                          defaultMessage="The client visits the bank's website and fills out a form"
                          description="Description for analytics day 13"
                        >
                          {linesToParagraphs}
                        </FormattedMessage>
                      </span>
                    </p>
                  </div>
                  <div className="landing__content--analytics-day18">
                    <h3>18</h3>
                    <p className="subtitle">
                      <FormattedMessage
                        id="landing.solutions_day"
                        defaultMessage="Day"
                        description="Day"
                      />
                      <span className="landing__content--analytics-wrap">
                        <FormattedMessage
                          id="landing.solutions_analytics.day18"
                          defaultMessage="The client visits the MFI website"
                          description="Description for analytics day 18"
                        >
                          {linesToParagraphs}
                        </FormattedMessage>
                      </span>
                    </p>
                  </div>
                  <div className="landing__content--analytics-day21">
                    <h3>21</h3>
                    <p className="subtitle">
                      <FormattedMessage
                        id="landing.solutions_day"
                        defaultMessage="Day"
                        description="Day"
                      />
                      <span className="landing__content--analytics-wrap">
                        <FormattedMessage
                          id="landing.solutions_analytics.day21"
                          defaultMessage="The client examines the requirements for the recipients of loans"
                          description="Description for analytics day 21"
                        >
                          {linesToParagraphs}
                        </FormattedMessage>
                      </span>
                    </p>
                  </div>
                  <div className="landing__content--analytics-day26">
                    <h3>26</h3>
                    <p className="subtitle">
                      <FormattedMessage
                        id="landing.solutions_day"
                        defaultMessage="Day"
                        description="Day"
                      />
                      <span className="landing__content--analytics-wrap">
                        <FormattedMessage
                          id="landing.solutions_analytics.day26"
                          defaultMessage="The client visits the site of another MFI and completes the questionnaire"
                          description="Description for analytics day 26"
                        >
                          {linesToParagraphs}
                        </FormattedMessage>
                      </span>
                    </p>
                  </div>
                  <div className="landing__content--analytics-customer">
                    Customer<br />journey
                  </div>
                </Col>
              </Row>
              {/*___________________________________________________*/}
              {/*______________V E R I F I C A T I O N______________*/}
              {/*___________________________________________________*/}
              <Row
                className="landing__content--verification"
                justify="space-between"
                type="flex"
              >
                <Col
                  className="landing__content--verification-img"
                  sm={24}
                  md={12}
                />
                <Col
                  className="landing__content--verification-desc"
                  sm={24}
                  md={12}
                >
                  <h2>
                    <FormattedMessage
                      id="landing.solutions_verification.title"
                      defaultMessage="Lead verification"
                      description="Verification section title"
                    />
                  </h2>
                  <FormattedMessage
                    id="landing.solutions_verification.description1"
                    defaultMessage="Conduster determines the authenticity of the leads and verifies them."
                    description="Verification section description p1"
                  />
                  <FormattedMessage
                    id="landing.solutions_verification.description2"
                    defaultMessage="Conduster determines the authenticity of the leads and verifies them."
                    description="Verification section description p2"
                    values={{
                      strong: (
                        <strong>
                          <FormattedMessage
                            id="landing.solutions_verification.strong"
                            defaultMessage="verified leads"
                            description="bold part of verification section description p2"
                          />
                        </strong>
                      )
                    }}
                  />
                  <ul>
                    <li>
                      <FormattedMessage
                        id="landing.solutions_verification.list-item1"
                        defaultMessage="filled out with a real person who really wants to take the action for which he filled in the form;"
                        description="Verification section list item 1"
                      />
                    </li>
                    <li>
                      <FormattedMessage
                        id="landing.solutions_verification.list-item2"
                        defaultMessage="contains genuine information about the person who filled in the form;"
                        description="Verification section list item 2"
                      />
                    </li>
                    <li>
                      <FormattedMessage
                        id="landing.solutions_verification.list-item3"
                        defaultMessage="fresh, sent recently;"
                        description="Verification section list item 3"
                      />
                    </li>
                    <li>
                      <FormattedMessage
                        id="landing.solutions_verification.list-item4"
                        defaultMessage="sold to only one buyer."
                        description="Verification section list item 4"
                      />
                    </li>
                  </ul>
                  <Graph
                    data={[
                      { name: "Point A", pv: 0 },
                      { name: "Point B", pv: 0 },
                      { name: "Point C", pv: 0 },
                      { name: "Point D", pv: 0 },
                      { name: "Point E", pv: 0 },
                      { name: "Point F", pv: 0 },
                      { name: "Point G", pv: 0 }
                    ]}
                  />
                </Col>
              </Row>
              <section className="landing__content--antifraud">
                <h2>
                  <FormattedMessage
                    id="landing.solutions_antifraud.title"
                    defaultMessage="Antifraud"
                    description="Section antifraud title"
                  />
                </h2>
                <p className="subtitle">
                  <FormattedMessage
                    id="landing.solutions_antifraud.subtitle"
                    defaultMessage="We eliminate all types of fraud by increasing ROI and eliminating ineffective marketing costs."
                    description="Section antifraud subtitle"
                  />
                </p>
                <Row
                  className="landing__content--antifraud-wrap"
                  justify="space-between"
                  type="flex"
                >
                  <Col
                    className="landing__content--antifraud-desc"
                    sm={24}
                    md={12}
                  >
                    <h3>
                      <FormattedMessage
                        id="landing.solutions_antifraud.list.title1"
                        defaultMessage="Protection against fraud"
                        description="Section antifraud list title"
                      />
                    </h3>
                    <p>
                      <FormattedMessage
                        id="landing.solutions_antifraud.list.desc1"
                        defaultMessage="Protection against fraud"
                        description="Section antifraud list description #1"
                      />
                    </p>
                    <h3>
                      <FormattedMessage
                        id="landing.solutions_antifraud.list.title2"
                        defaultMessage="Brand Security"
                        description="Section antifraud list title"
                      />
                    </h3>
                    <p>
                      <FormattedMessage
                        id="landing.solutions_antifraud.list.desc2"
                        defaultMessage="Protection against fraud"
                        description="Section antifraud list description #2"
                      />
                    </p>
                  </Col>
                  <Col
                    className="landing__content--antifraud-img"
                    sm={24}
                    md={12}
                  />
                </Row>
              </section>
            </div>
          </div>
        </Content>
        {/*___________________________________________________*/}
        {/*_________________ F O O T E R  ____________________*/}
        {/*___________________________________________________*/}
        <LandingFooter />
      </Layout>
    );
  }
}

export default Solutions;



// WEBPACK FOOTER //
// ./src/components/landing/Solutions.js